import styled from 'styled-components';

export const Feed = styled.div`
	padding: 20px;
`;

export const Account = styled.a`
	font-weight: bold;
	color: #f8931f;
	text-decoration: none;
	font-size: 24px;
    font-family: 'Helvetica';
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	margin: 10px 0;
`;

export const Post = styled.a`
	padding: 0 5px;
`;

export const Image = styled.img`
	width: 100%;
	height: auto;
`;